<div class="login2background" style="background-image: url(assets/img/global/fundo_login.jpg)">
  <div class="main-content container-fluid">
    <div class="splash-container">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <img src="assets/img/global/thumb_up.png" alt="ok">
              <span class="float-right"><b>Seu registro foi enviado com sucesso.</b> Uma senha provisória de acesso foi
                direcionada ao seu e-mail. O acesso será possível após autorizado pelo administrador do sistema.</span>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <a routerLink="/login" class="btn btn-link btn-sm float-right mr-3">Voltar</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
